<template>
	<ClientOnly>
		<v-menu
			v-if="!isMobile"
			v-model="isLocationMenuOpen"
			:attach="!nav"
			:close-on-content-click="false"
			scrim
			close-on-back
			:scroll-strategy="customScrollStrategy"
			:content-class="{ 'booker-location': true, 'booker-location__nav': nav }"
			:style="`z-index: 2100; --nav-offset: ${(navHeight ?? 0) + y}px; --booker-offset: ${bookerOffset}px`">
			<GlobalBookerLocationContainer v-model="isLocationMenuOpen" :type></GlobalBookerLocationContainer>
		</v-menu>
		<v-dialog
			v-else
			v-model="isLocationMenuOpen"
			fullscreen
			scroll-strategy="none"
			:content-class="{ 'booker-location': true, 'booker-location__nav': nav }"
			:style="`z-index: 2100;`">
			<GlobalBookerLocationContainer v-model="isLocationMenuOpen" :type></GlobalBookerLocationContainer>
		</v-dialog>
	</ClientOnly>
</template>

<script lang="ts" setup>
import { EBookerLocationType } from '@/data/bookerData'

const isLocationMenuOpen = defineModel<boolean>()
const navHeight = inject<Ref<number | undefined>>('navHeight')
const bookerWidth = inject<Ref<number | undefined>>('bookerWidth')
const locationModalOffset = inject<Ref<number | undefined>>('locationModalOffset')
const props = defineProps<{
	type: EBookerLocationType
	nav?: boolean
}>()

const { y } = useWindowScroll()
const { isMobile } = useWindowWidth()
const initialScrollY = ref(0)

const bookerOffset = computed(() => {
	return props.type === EBookerLocationType.START ? bookerWidth?.value : locationModalOffset?.value
})

const customScrollStrategy = () => {
	initialScrollY.value = window.scrollY

	const handleScroll = () => {
		const scrolledDistance = Math.abs(window.scrollY - initialScrollY.value)
		if (scrolledDistance > 150) {
			isLocationMenuOpen.value = false
		}
	}
	window.addEventListener('scroll', handleScroll)
	return () => {
		window.removeEventListener('scroll', handleScroll)
	}
}
</script>

<style lang="scss">
@import './LocationMenu';
</style>
